import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    trackEvent,
    trackPageView,
    getPuzzleRouteContext,
    getPuzzleTrafficEventName,
    onAnalyticsReady,
} from "../../services/GoogleAnalytics";

function trackRouteVisit(location) {
    const isAdminPath = location.pathname === "/admin" || location.pathname.startsWith("/admin/");
    if (isAdminPath) return;

    const fullPath = location.pathname + location.search;
    trackPageView(fullPath);

    const puzzleContext = getPuzzleRouteContext(location.pathname);
    const baseParams = {
        page_path: fullPath,
        page_location: typeof window !== "undefined" ? window.location.href : fullPath,
        ...(puzzleContext || {}),
    };

    trackEvent("route", baseParams);

    const puzzleTrafficEvent = puzzleContext?.puzzle_type
        ? getPuzzleTrafficEventName(puzzleContext.puzzle_type)
        : null;
    if (puzzleTrafficEvent) {
        trackEvent(puzzleTrafficEvent, baseParams);
    }
}

/**
 * Tracks GA page_path (config) + route / puzzle traffic events on every navigation.
 * Re-fires when analytics consent loads mid-session so early visits are not lost.
 */
const PageViewTracker = () => {
    const location = useLocation();

    useEffect(() => {
        trackRouteVisit(location);
        return onAnalyticsReady(() => trackRouteVisit(location));
    }, [location]);

    return null;
};

export default PageViewTracker;
